import {ModelBase} from "../../../models/model-base";
import {DayKey} from "../../../_shared/time/company-day";

export class ContractBase extends ModelBase {
  /** The contract's first day, `yyyy-MM-dd` (#802). */
  validFrom: DayKey = '';
  /**
   * The contract's last day, `yyyy-MM-dd`, included: a contract 01.09.–30.09. arrives as `'2026-09-30'` and is shown
   * as 30.09. The server checks moments against it until midnight after that day; the page only shows the day.
   */
  validTo: DayKey = '';
  shardCount: number = 0;
  deviceCount: number = 0;
  minimalMonthsPerDevice: number = 1;
  /**
   * How many **virtual events** (#664) may run in parallel across the whole company while this contract is
   * valid. `-1` means unlimited and renders as `∞`, exactly like {@link shardCount}/{@link deviceCount};
   * `0` — the default for every contract that predates the feature — means virtual events are not licensed.
   */
  virtualEventCount: number = 0;
}

/**
 * Whether the contract covers the calendar day `day` (`yyyy-MM-dd`). Both ends are included, and day keys compare
 * correctly as strings, so no `Date` and no zone is involved.
 */
export function contractCoversDay(contract: Pick<ContractBase, 'validFrom' | 'validTo'>, day: DayKey): boolean {
  return contract.validFrom <= day && day <= contract.validTo;
}

/** Whether the contract's last day lies before `day`. */
export function contractEndedBefore(contract: Pick<ContractBase, 'validTo'>, day: DayKey): boolean {
  return contract.validTo < day;
}

/** Whether the contract's first day lies after `day`. */
export function contractStartsAfter(contract: Pick<ContractBase, 'validFrom'>, day: DayKey): boolean {
  return contract.validFrom > day;
}
